import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { SelectOption, FormSelectProps } from '@ui';
import { AccountUsePercentageOptions } from 'enums/onboarding/crm';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const AccountUsePercentageSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(AccountUsePercentageOptions).map((key) => ({
        id: key,
        label: t(`intake_form.account_use_operations.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default AccountUsePercentageSelect;
